<template>
  <div>
    <div @click="visible = true">
      <a-button
        v-if="canEdit"
        type="primary"
        style="background: #ff8c18; border: 1px solid #ff8c18"
        icon="plus"
      >
        添加
      </a-button>
    </div>

    <a-modal
      :visible="visible"
      title="添加采购申请清单"
      :footer="null"
      @cancel="visible = false"
    >
      <a-form :form="form" :colon="false" @submit="handleSubmit">
        <a-form-item
          label="分类"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-select
            v-decorator="[
              'category',
              { rules: [{ required: true, message: '请选择！' }] },
            ]"
          >
            <a-select-option
              v-for="item in ['办公文具用品', '电脑周边', '打印耗材', '劳保用品']"
              :key="item"
              :value="item"
            >
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          label="商品名称"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input
            v-decorator="[
              'name',
              { rules: [{ required: true, message: '请输入！' }] },
            ]"
          />
        </a-form-item>

        <a-form-item
          label="规格型号"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input
            v-decorator="[
              'spec',
              { rules: [{ required: true, message: '请输入！' }] },
            ]"
          />
        </a-form-item>

        <a-form-item
          label="颜色"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input
            v-decorator="[
              'color',
              { rules: [{ required: true, message: '请输入！' }] },
            ]"
          />
        </a-form-item>

        <a-form-item
          label="单位"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input
            v-decorator="[
              'unit',
              { rules: [{ required: true, message: '请输入！' }] },
            ]"
          />
        </a-form-item>

        <a-form-item
          label="单价(元)"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input-number
            :formatter="$inputNumberFormat"
            :min="0"
            style="width: 100%"
            v-decorator="[
              'price',
              { rules: [{ required: true, message: '请输入！' }] },
            ]"
          />
        </a-form-item>

        <a-form-item
          label="申领数量"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input-number
            :min="0"
            style="width: 100%"
            v-decorator="[
              'amount',
              { rules: [{ required: true, message: '请输入！' }] },
            ]"
          />
        </a-form-item>

        <a-form-item
          label="备注"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-textarea
            v-decorator="['remark']"
            :auto-size="{ minRows: 2, maxRows: 5 }"
          />
        </a-form-item>

        <div class="right">
          <a-space>
            <a-button type="primary" html-type="submit">保存</a-button>
            <a-button @click="visible = false">关闭</a-button>
          </a-space>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: "addMaterialInput",
  props: {
    canEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      form: this.$form.createForm(this),
    };
  },

  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          // 手动输入的物资没有真实 id，生成临时唯一标识，
          // 便于父组件列表渲染 key 与去重判断
          this.$emit("add", {
            ...values,
            id: Date.now(),
          });

          this.visible = false;
          this.form.resetFields();
        }
      });
    },
  },
};
</script>
